import React, { useState } from 'react';
import { FiChevronDown, FiEye } from 'react-icons/fi';

/**
 * Groups panel — flex row: [icon] [input flex-1] [count slot] [arrow]
 */
const GroupsInlineSearchField = ({
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder,
  disabled = false,
  dropdownOpen = false,
  onToggleDropdown,
  selectionCount = 0,
  selectionSummary = null,
  toggleAriaLabel = 'Toggle list',
  showViewSelected = false,
  onViewSelected = null,
  viewSelectedTooltip = 'View selected items',
}) => {
  const [focused, setFocused] = useState(false);
  const hasCount = selectionCount > 0;
  const showSummary = Boolean(selectionSummary) && !String(value || '').trim() && !focused;
  const showCount = hasCount && !showSummary;

  return (
    <div className="assess-mod-groups-inline-search">
      <div
        className={`assess-mod-groups-inline-search-field${
          focused ? ' is-focused' : ''
        }${disabled ? ' is-disabled' : ''}${showCount ? ' has-count' : ''}`}
      >
        <span className="assess-mod-groups-inline-search-icon-wrap" aria-hidden>
          <i className="bi bi-search assess-mod-groups-inline-search-icon" />
        </span>

        <div className="assess-mod-groups-inline-search-input-wrap">
          {showSummary && (
            <div className="assess-mod-groups-inline-search-summary" aria-hidden>
              {selectionSummary}
            </div>
          )}
          <input
            type="text"
            disabled={disabled}
            className={`assess-mod-groups-inline-search-input${
              showSummary ? ' assess-mod-groups-inline-search-input--summary' : ''
            }`}
            placeholder={showSummary ? '' : placeholder}
            value={value}
            onFocus={(e) => {
              setFocused(true);
              onFocus?.(e);
            }}
            onBlur={(e) => {
              setFocused(false);
              onBlur?.(e);
            }}
            onChange={onChange}
          />
        </div>

        {showCount && (
          <div
            className="assess-mod-groups-inline-search-count-slot"
            title={`${selectionCount} selected`}
            aria-label={`${selectionCount} selected`}
          >
            <span className="assess-mod-groups-inline-search-count assess-mod-groups-inline-search-count--full">
              {selectionCount} selected
            </span>
            <span className="assess-mod-groups-inline-search-count assess-mod-groups-inline-search-count--short" aria-hidden>
              {selectionCount} sel.
            </span>
          </div>
        )}
        {showViewSelected && (
          <div className="assess-mod-groups-inline-search-eye-slot flex-shrink-0 flex items-center justify-center">
            <button
              type="button"
              disabled={disabled}
              className="assess-mod-groups-inline-search-eye-btn p-1 rounded hover:bg-slate-100 transition-colors flex items-center justify-center cursor-pointer border-0 bg-transparent text-slate-500 hover:text-slate-800"
              onClick={(e) => {
                e.stopPropagation();
                onViewSelected?.();
              }}
              title={viewSelectedTooltip}
            >
              <FiEye style={{ fontSize: '1rem' }} />
            </button>
          </div>
        )}

        <div className="assess-mod-groups-inline-search-arrow-slot">
          <button
            type="button"
            disabled={disabled}
            className="assess-mod-groups-inline-search-toggle"
            aria-label={toggleAriaLabel}
            onClick={(e) => {
              e.stopPropagation();
              onToggleDropdown?.();
            }}
          >
            <FiChevronDown
              className={`assess-mod-groups-inline-search-chevron${
                dropdownOpen ? ' is-open' : ''
              }`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupsInlineSearchField;
